import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import Ranus from "./assets/Ranus.svg";
import TFUSelect from "../based/inputs/TFUSelect";
import Breadcrumbs from "../based/Breadcrumbs";
import OrderServices from "../based/services/OrderServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import PrintReturnLabelModal from "./PrintReturnLabelModal";

//Trạng thái sản phẩm trả về: Tốt/Có thể sửa/Không thể sửa (Do Ranus)/Không thể sửa (Do khách)
const StatusProduct = {
    GOOD: 1,
    REPAIRABLE: 2,
    NOT_REPAIRABLE_RANUS: 3,
    NOT_REPAIRABLE_CUSTOMER: 4,
};
const STATUS_PRODUCT_OPTIONS = [
    { value: StatusProduct.GOOD, label: "Tốt" },
    { value: StatusProduct.REPAIRABLE, label: "Có thể sửa" },
    { value: StatusProduct.NOT_REPAIRABLE_RANUS, label: "Không thể sửa (Do Ranus)" },
    { value: StatusProduct.NOT_REPAIRABLE_CUSTOMER, label: "Không thể sửa (Do khách)" },
];

function ReturnOrderCheck(props) {
    const [inputValue, setInputValue] = useState("");
    const [model, setModel] = useState({});
    const [showPrintModal, setShowPrintModal] = useState(false);

    console.log("model", model);

    const handleCheckOrder = async (inputValue) => {
        //kiểm tra lấy ra order id
        if (inputValue) {
            const orderId = await checkWhetherOrderIdNumber(inputValue);
            if (orderId > 0) {
                const [err, data] = await OrderServices.GetOrderReturnManageModelsById(orderId);
                if (!err && data) {
                    let dt = { ...data };
                    let products = dt.orderReturnProductManageModels;
                    for (var element of products) {
                        if (element.isReturnDefective && !element.quantityReceived) {
                            element.quantityReceived = element.quantityReturned; // Set default quantity received to quantity returned if not set
                        }
                    }

                    setModel(dt);
                    setInputValue(""); // Clear input field after successful fetch
                }
            } else {
                Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Không tìm thấy mã đơn hàng");
            }
        }
    };

    //kiểm tra mã đơn hàng
    const checkWhetherOrderIdNumber = async (orderIdNumber) => {
        const [err, data] = await OrderServices.GetOrderIdByWhetherOrderIdNumber(orderIdNumber);
        return data;
    };

    const handleSave = async () => {
        if (model && model.id > 0 && model.orderReturnProductManageModels) {
            const [err] = await OrderServices.UpdateOrderReturnProduct(model.orderReturnProductManageModels);
            if (!err) {
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Cập nhật đơn hoàn về thành công");
                setInputValue(""); // Clear input field
            } else {
                Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Cập nhật đơn hoàn về thất bại");
            }
        }
    };

    const convertToColor = (status) => {
        switch (status) {
            case StatusProduct.GOOD:
                return "green"; // Green
            case StatusProduct.REPAIRABLE:
                return "purple"; // Yellow
            case StatusProduct.NOT_REPAIRABLE_RANUS:
                return "red"; // Red
            case StatusProduct.NOT_REPAIRABLE_CUSTOMER:
                return "red"; // Gray
            default:
                return ""; // Default color
        }
    };

    const quantityAnalysis = useMemo(() => {
        //lấy ra số lượng trả về, số lượng nhận
        //số lượng tốt, số lượng có thể sửa, số lượng không thể sửa
        if (!model || !model.orderReturnProductManageModels) return null;
        let totalReturned = 0; //số lượng trả về
        let totalReceived = 0; //số lượng nhận được
        let totalGood = 0; //số lượng tốt
        let totalRepairable = 0; //số lượng có thể sửa
        let totalNotRepairableRanus = 0; //số lượng không thể sửa (do Ranus)
        let totalNotRepairableCustomer = 0; //số lượng không thể sửa (do khách)
        model.orderReturnProductManageModels.forEach((item) => {
            if (item.isReturnDefective) {
                totalReturned += item.quantityReturned; // Default to 1 if quantityReturned is not set
                totalReceived += item.quantityReceived; // Default to 0 if quantityReceived is not set

                switch (item.returnProductStatus) {
                    case StatusProduct.GOOD:
                        totalGood += item.quantityReceived || 0;
                        break;
                    case StatusProduct.REPAIRABLE:
                        totalRepairable += item.quantityReceived || 0;
                        break;
                    case StatusProduct.NOT_REPAIRABLE_RANUS:
                        totalNotRepairableRanus += item.quantityReceived || 0;
                        break;
                    case StatusProduct.NOT_REPAIRABLE_CUSTOMER:
                        totalNotRepairableCustomer += item.quantityReceived || 0;
                        break;
                }
            }
        });
        return {
            totalReturned,
            totalReceived,
            totalGood,
            totalRepairable,
            totalNotRepairableRanus,
            totalNotRepairableCustomer,
        };
    }, [model]);

    return (
        <>
            <Wrapper>
                <Breadcrumbs currentPage="Kiểm tra đơn hoàn về" />
                <section className="return-page">
                    <section className="return-left">
                        <section className="return-input">
                            <section className="return-scan-code">
                                <div className="input-area">
                                    <input
                                        type="text"
                                        placeholder="Nhập mã đơn hàng"
                                        value={inputValue}
                                        onChange={(e) => {
                                            let length = e.target.value.length;
                                            setInputValue(e.target.value);
                                            if (length == 10) {
                                                handleCheckOrder(e.target.value);
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleCheckOrder(inputValue);
                                            }
                                        }}
                                        autoFocus
                                    />
                                    <button
                                        className="scan-button"
                                        onClick={(e) => {
                                            handleCheckOrder(inputValue);
                                        }}
                                    >
                                        Kiểm tra
                                    </button>
                                </div>
                                {model && (
                                    <>
                                        <div className="grid-logo">
                                            <img src={Ranus} alt="" />
                                        </div>
                                        <div className="grid-order-id">
                                            <label>Đơn hàng gốc</label>
                                            <span>{model.orderId}</span>
                                        </div>
                                        <div className="grid-order-number">
                                            <label htmlFor="transit-code">Mã hoàn về</label>
                                            <span></span>
                                        </div>
                                    </>
                                )}
                            </section>
                            {model && (
                                <section className="list-info">
                                    <div className="info-group">
                                        <label htmlFor="">Tên</label>
                                        <span>{model.userName}</span>
                                    </div>
                                    <div className="info-group">
                                        <label htmlFor="">SĐT</label>
                                        <span>{model.phoneNumber}</span>
                                    </div>
                                    <div className="info-group">
                                        <label htmlFor="">Địa chỉ</label>
                                        {model.id > 0 && <span>{`${model.street}, ${model.wardName}, ${model.districtName}, ${model.provinceName}`}</span>}
                                    </div>
                                </section>
                            )}
                        </section>
                        <section className="return-video"></section>
                    </section>
                    <section className="return-right">
                        <section className="return-analysis">
                            {quantityAnalysis && (
                                <>
                                    <div className="return-header">
                                        <h6>Sản phẩm trả về ({quantityAnalysis.totalReturned})</h6>
                                        <p className="instruct-header">Kiểm tra số lượng và chất lượng của sản phẩm</p>
                                    </div>
                                    <div className="line"></div>
                                    <div className="header-item">
                                        <div className="header-item-main">Đã nhận</div>
                                        <div className="header-item-count">{quantityAnalysis.totalReceived}</div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="header-item">
                                        <div className="header-item-main">Sản phẩm tốt</div>
                                        <div className="header-item-count green">{quantityAnalysis.totalGood}</div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="header-item">
                                        <div className="header-item-main">Có thể sửa</div>
                                        <div className="header-item-count purple">{quantityAnalysis.totalRepairable}</div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="header-item">
                                        <div className="header-item-main">Không thể sửa</div>
                                        <div className="header-item-count red">{quantityAnalysis.totalNotRepairableRanus + quantityAnalysis.totalNotRepairableCustomer}</div>
                                    </div>
                                </>
                            )}
                            <div className="header-btn">
                                <button
                                    className={`btn btn-custom ${model && model.id > 0 ? "" : "disabled"}`}
                                    onClick={async (e) => {
                                        await handleSave();
                                        setShowPrintModal(true);
                                    }}
                                >
                                    Đã nhận hàng và lưu kho
                                </button>
                            </div>
                        </section>

                        <section className="return-table">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Hình ảnh</th>
                                        <th>Sản phẩm</th>
                                        <th>SL trả</th>
                                        <th>SL nhận được</th>
                                        <th>Tình trạng</th>
                                        <th>Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {model.orderReturnProductManageModels &&
                                        model.orderReturnProductManageModels.map((item, index) => {
                                            if (!item.isReturnDefective) return null; // Skip items that are not marked as return defective
                                            return (
                                                <tr key={index}>
                                                    <td className="image-td">
                                                        <div className="lst-image">
                                                            {item.frontImage && <img src={item.frontImage} alt="Front" />}
                                                            {item.backImage && <img src={item.backImage} alt="Back" />}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="prduct-info">
                                                            {/* <p className="link-info">{item.productLink}</p> */}
                                                            <p className="product-name">{item.appProductName}</p>
                                                            <p className="product-attribute">{`Size: ${item.size}, Màu: ${item.color}`}</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <p className="number">{item.quantityReturned || 1}</p>
                                                    </td>
                                                    <td>
                                                        <div className="number-change-area">
                                                            <div
                                                                className="decrease-btn cursor-pointer"
                                                                onClick={(e) => {
                                                                    let md = { ...model };
                                                                    let element = md.orderReturnProductManageModels[index];
                                                                    if (element.quantityReceived >= 1) {
                                                                        element.quantityReceived--;
                                                                        setModel(md);
                                                                    }
                                                                }}
                                                            >
                                                                -
                                                            </div>
                                                            <input type="text" className="number-input" value={item.quantityReceived} readOnly />
                                                            <div
                                                                className="increase-btn cursor-pointer"
                                                                onClick={(e) => {
                                                                    let md = { ...model };
                                                                    let element = md.orderReturnProductManageModels[index];

                                                                    //nếu số lượng lớn hơn số lượng trả thì không tăng
                                                                    if (element.quantityReceived >= item.quantityReturned) {
                                                                        return;
                                                                    }
                                                                    //tăng số lượng nhận
                                                                    element.quantityReceived++;
                                                                    setModel(md);
                                                                }}
                                                            >
                                                                +
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className={`select-btn ${convertToColor(item.returnProductStatus)}`}>
                                                            <TFUSelect
                                                                name={`returnProductStatus-${index}`}
                                                                options={STATUS_PRODUCT_OPTIONS}
                                                                placeholder="Chọn tình trạng"
                                                                value={item.returnProductStatus}
                                                                onChangedObject={(newVal) => {
                                                                    let md = { ...model };
                                                                    let element = md.orderReturnProductManageModels[index];
                                                                    element.returnProductStatus = newVal ? newVal.value : -1;
                                                                    setModel(md);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="add-note">
                                                            <input
                                                                type="text"
                                                                placeholder="Thêm ghi chú"
                                                                value={item.note || ""}
                                                                onChange={(e) => {
                                                                    let md = { ...model };
                                                                    let element = md.orderReturnProductManageModels[index];
                                                                    element.note = e.target.value;
                                                                    setModel(md);
                                                                }}
                                                            />
                                                            <button className="add-note-btn">
                                                                <i className="fa fa-camera"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </section>
                    </section>
                </section>
            </Wrapper>
            {model && model.id > 0 && <PrintReturnLabelModal show={showPrintModal} onClose={() => setShowPrintModal(false)} orderId={model.orderId} />}
        </>
    );
}

export default ReturnOrderCheck;

const Wrapper = styled.div`
    .red {
        color: #ffc6ca !important;
    }

    .green {
        color: #cdffdf !important;
    }

    .purple {
        color: #fccdff !important;
    }

    .select-btn.red {
        div {
            background: #ffc6ca;
            color: black;
        }
    }
    .select-btn.green {
        div {
            background: #cdffdf;
            color: black;
        }
    }

    .select-btn.purple {
        div {
            background: #fccdff;
            color: black;
        }
    }

    /* table ds */
    section.return-table {
        margin-top: 24px;
    }

    td.image-td {
        width: 240px;
    }

    .lst-image {
        display: flex;
    }

    .lst-image img {
        width: 100px;
        margin: 10px;
    }

    .table thead {
        background: #d9d9d9;
    }

    tbody tr {
        background: #fff;
    }

    p.link-info {
        color: #13aaff;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 12px 0;
    }

    p.product-name {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 12px 0;
    }

    p.product-attribute {
        margin: 12px 0;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .prduct-info {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    p.number {
        color: #444;
        font-family: Roboto;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin: 12px 0;
    }

    .number-change-area {
        display: flex;
        align-items: center;
        margin: 12px 0;
    }

    .decrease-btn {
        width: 24px;
        height: 34px;
        border: 1px;
        background: #eaeaea;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    input.number-input {
        height: 34px;
        width: 40px;
        border: 1px solid #d9d9d9;
        background: #fff;
        text-align: center;
    }

    .increase-btn {
        width: 24px;
        height: 34px;
        border: 1px;
        background: #eaeaea;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .select-btn {
        width: 200px;
        margin: 12px 0;
    }

    .add-note {
        display: flex;
        flex-wrap: wrap;
    }

    .add-note input {
        width: 100%;
        border: 1px solid #e5e5e5;
        background: #f1f1f1;
        margin: 12px 0;
    }

    button.add-note-btn {
        border: 1px solid #e5e5e5;
        background: #f1f1f1;
        width: 42px;
        height: 42px;
    }

    /* sản phẩm trả về */
    section.return-page {
        display: flex;
    }

    section.return-left {
        width: 400px;
    }

    section.return-right {
        flex: 1;
        margin-left: 20px;
    }

    section.return-input {
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 16px 20px;
    }

    section.return-scan-code {
        display: grid;
        grid-template-columns: auto auto;
        grid-auto-rows: auto auto;
    }

    .input-area {
        grid-column: 1/3;
        display: flex;
    }

    .grid-logo {
        grid-column: 1/3;
        padding: 12px 16px;
    }

    section.return-scan-code > div {
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .input-area input {
        flex: 1;
        border: none;
        padding: 12px 0 12px 20px;
    }

    .input-area button {
        height: 100%;
        border: 1px solid #d9d9d9;
        background: #64c5b1;
        padding: 12px 20px;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .grid-order-id {
        padding: 12px;
        display: flex;
        flex-direction: column;
    }

    .grid-order-id label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .grid-order-id span {
        color: #13aaff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .grid-order-number {
        padding: 12px;
        display: flex;
        flex-direction: column;
    }

    .grid-order-number label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .grid-order-number span {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .info-group {
        display: flex;
        align-items: baseline;
        margin: 10px 0;
    }

    .info-group label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        width: 30%;
        margin: 0;
    }

    .info-group span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        flex: 1;
    }

    section.list-info {
        margin: 12px 0;
    }

    section.return-analysis {
        display: flex;
        align-items: center;
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 18px 12px;
    }

    .header-btn {
        margin-left: auto;
    }

    .return-header h6 {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    p.instruct-header {
        color: #444;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .line {
        width: 1.5px;
        height: 40px;
        background: #e5e5e5;
        margin: 0 24px;
    }

    .header-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .header-item-main {
        color: #a4a4a4;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    .header-item-count {
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 66.667% */
        margin-top: 8px;
    }

    /* scan mã */
    section.return-page {
        display: flex;
    }

    section.return-left {
        width: 400px;
    }

    section.return-right {
        flex: 1;
        margin-left: 20px;
    }

    section.return-input {
        border: 1px solid #f1f1f1;
        background: #fff;
        padding: 16px 20px;
    }

    section.return-scan-code {
        display: grid;
        grid-template-columns: auto auto;
        grid-auto-rows: auto auto;
    }

    .input-area {
        grid-column: 1/3;
        display: flex;
    }

    .grid-logo {
        grid-column: 1/3;
        padding: 12px 16px;
    }

    section.return-scan-code > div {
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .input-area input {
        flex: 1;
        border: none;
        padding: 12px 0 12px 20px;
    }

    .input-area button {
        height: 100%;
        border: 1px solid #d9d9d9;
        background: #64c5b1;
        padding: 12px 20px;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .grid-order-id {
        padding: 12px;
        display: flex;
        flex-direction: column;
    }

    .grid-order-id label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .grid-order-id span {
        color: #13aaff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .grid-order-number {
        padding: 12px;
        display: flex;
        flex-direction: column;
    }

    .grid-order-number label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .grid-order-number span {
        color: #444;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .info-group {
        display: flex;
        align-items: baseline;
        margin: 10px 0;
    }

    .info-group label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        width: 30%;
        margin: 0;
    }

    .info-group span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    section.list-info {
        margin: 12px 0;
    }
`;
